// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_sfSTM {
  margin-bottom: 14px;
}

.title_ZBwg2 {
  font-size: 18px;
  font-weight: 600;
  color: #222222;
  margin: 0 0 16px 0;
}

.colorGroup_wIyjx {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.colorGroup_wIyjx:last-child {
  margin-bottom: 0;
}

.label_Xc712 {
  font-size: 14px;
  font-weight: 500;
  color: #6B7280;
  margin: 0;
  flex-shrink: 0;
}

.colorInputWrapper_qXUvG {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #F4F4F4;
  min-width: 120px;
  flex-shrink: 0;

}


.colorInput_frTQ2 {
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  flex-shrink: 0;
}

.colorInput_frTQ2::-webkit-color-swatch-wrapper {
  height: 24px;
  width: 24px;
  padding: 0;
  border: none;
  border-radius: 50%;
}

.colorInput_frTQ2::-webkit-color-swatch {
  border: 1px solid #D1D5DB;
  border-radius: 50%;
  height: 24px;
  width: 24px;
}

.hexInput_mMw92 {
  flex: 1 1;
  border: none;
  background: transparent;
  font-size: 14px;
  color: #6B7280;
  outline: none;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
}

.hexInput_mMw92::placeholder {
  color: #9CA3AF;
} `, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/ColorSettings/ColorSettings.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;;AAEhB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,aAAa;EACb,wDAAwD;AAC1D;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".container {\n  margin-bottom: 14px;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #222222;\n  margin: 0 0 16px 0;\n}\n\n.colorGroup {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.colorGroup:last-child {\n  margin-bottom: 0;\n}\n\n.label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #6B7280;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.colorInputWrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  background: #F4F4F4;\n  min-width: 120px;\n  flex-shrink: 0;\n\n}\n\n\n.colorInput {\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.colorInput::-webkit-color-swatch-wrapper {\n  height: 24px;\n  width: 24px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n}\n\n.colorInput::-webkit-color-swatch {\n  border: 1px solid #D1D5DB;\n  border-radius: 50%;\n  height: 24px;\n  width: 24px;\n}\n\n.hexInput {\n  flex: 1;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  color: #6B7280;\n  outline: none;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n}\n\n.hexInput::placeholder {\n  color: #9CA3AF;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_sfSTM`,
	"title": `title_ZBwg2`,
	"colorGroup": `colorGroup_wIyjx`,
	"label": `label_Xc712`,
	"colorInputWrapper": `colorInputWrapper_qXUvG`,
	"colorInput": `colorInput_frTQ2`,
	"hexInput": `hexInput_mMw92`
};
export default ___CSS_LOADER_EXPORT___;
